export default function registerPage() {
  const selectors = {
    registerPage: '.template-register',
    customerRegisterForm: '#create_customer',
    inputPass: '[data-register-password]',
    inputPassRepeat: '[data-register-password-repeat]',
    inputEmail: '[data-register-email]',
  }

  const registerPageElement = document.querySelector(selectors.registerPage);
  const customerRegisterFormElement = document.querySelector<HTMLFormElement>(selectors.customerRegisterForm);
  const inputPassEl = document.querySelector<HTMLInputElement>(selectors.inputPass);
  const inputPassRepeatEl = document.querySelector<HTMLInputElement>(selectors.inputPassRepeat);
  const inputEmailEl = document.querySelector<HTMLInputElement>(selectors.inputEmail);
  const wigInProgress = JSON.parse(localStorage.getItem('wigInProgress'));

  if (!registerPageElement) return;

  const checkPassword = (e: any) => {
    const submitButton = inputPassRepeatEl.parentElement.parentElement.querySelector<HTMLButtonElement>('button');

    if (inputPassRepeatEl.value === inputPassEl.value) {
      submitButton.disabled = false;
    } else {
      submitButton.disabled = true;
    }
  }

  const handleEmailError = () => {
    return `
      <svg class="w-[16px] h-[16px] mr-2.5">
        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2" />
        <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7" />
        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white" />
        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7" />
      </svg>
      Email can't be blank.
    `
  }

  const handlePasswordError = () => {
    return `
      <svg class="w-[16px] h-[16px] mr-2.5">
        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2" />
        <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7" />
        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white" />
        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7" />
      </svg>
      Password is too short (minimum is 5 characters).
    `
  }

  const handleRegisterFormSubmit = async (e: any) => {
    e.preventDefault();

    if (inputEmailEl.value === '') {
      const div = document.createElement('div');
      div.classList.add('text-sm', 'leading-none', 'flex', 'mt-2.5');
      div.innerHTML = handleEmailError();

      inputEmailEl.parentElement.append(div)

      return
    }

    if (inputPassEl.value === inputPassRepeatEl.value) {
      if (inputPassEl.value.length > 4) {
        const formData = new FormData(customerRegisterFormElement);

        await fetch('/account', {
          method: 'POST',
          body: formData,
        })
          .catch(error => {
            console.log(error);
          });

        location.href = '/';
      } else {
        const div = document.createElement('div');
        div.classList.add('text-sm', 'leading-none', 'flex', 'mt-2.5', 'text-left');
        div.innerHTML = handlePasswordError();
        inputPassRepeatEl.parentElement.append(div);
      }
    }
  }

  customerRegisterFormElement.addEventListener('submit', handleRegisterFormSubmit)
  inputPassEl.addEventListener('input', checkPassword);
  inputPassRepeatEl.addEventListener('input', checkPassword);

  if (!wigInProgress) return;

  const redirectURL = wigInProgress;
  const htmlInput = document.createElement('input');

  htmlInput.type = 'hidden';
  htmlInput.name = 'return_to';
  htmlInput.value = redirectURL;

  customerRegisterFormElement.append(htmlInput);
}

registerPage();
